import React from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

import { rowCountOf } from '../services/aiDataUtils';
import { formatRefreshedAt } from '../services/aiFormatters';
import { CHART_TYPES, chartTypeLabel, detectChartType } from '../services/chartTypeUtils';

import InlineProgress from './InlineProgress';

function TypeIcon({ spec }) {
  const type = detectChartType(spec);
  const entry = CHART_TYPES.find(t => t.value === type);
  const Icon = entry ? entry.Icon : CHART_TYPES[0].Icon;
  return <Icon fontSize="small" />;
}

export default function SavedChartsList({ charts, selectedChartId, opLabels = {}, onSelect }) {
  if (!charts || charts.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ px: 1, py: 0.5 }}>
        No saved charts.
      </Typography>
    );
  }

  return (
    <Box>
      {charts.map(chart => {
        const rows = rowCountOf(chart);
        const refreshedLabel = formatRefreshedAt(chart.lastRefreshedAt);
        const active = chart.id === selectedChartId;
        return (
          <Box key={chart.id} className={`saved-chart-item ${active ? 'active' : ''}`} onClick={() => onSelect(chart)}>
            <Typography variant="body2" noWrap sx={{ fontWeight: 500, mb: 0.5 }}>
              {chart.title}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Chip
                size="small"
                icon={<TypeIcon spec={chart.vegaSpec} />}
                label={chartTypeLabel(chart.vegaSpec)}
                variant="outlined"
              />
              {rows != null && (
                <Typography variant="caption" color="text.secondary">
                  {rows} Rows of Results
                </Typography>
              )}
            </Box>
            {refreshedLabel && (
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.25 }}>
                Refreshed {refreshedLabel}
              </Typography>
            )}
            {opLabels[chart.id] && <InlineProgress label={opLabels[chart.id]} dense />}
          </Box>
        );
      })}
    </Box>
  );
}
